export default __webpack_public_path__ + "static/media/33.d5fb12f3.jpg";